const getQueryParam = (name: string, url?: string) => {
    let uri = decodeURIComponent(url || window.location.search);
    let reg = new RegExp('[?&]' + name + '=([^&?#]*)', 'i');
    let re = uri.match(reg);
    return re && re[1] || '';
}
export default getQueryParam;
